class Keyboard {
    constructor(plugins) {
        this.__keyboard = plugins.keyboard || {};
    }

    hide() {
        if (this.__keyboard && this.__keyboard.hide) {
            this.__keyboard.hide();
        }
    }
}

export default Keyboard;
